/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {FC} from 'react';
import {Text, View} from 'react-native';
import {formsStyles} from '../formStyles';

interface Props {
  label: string;
  required: boolean;
}

export const TitleLabel: FC<Props> = props => {
  const {label = '', required = false} = props;
  return (
    <View>
      {label && (
        <Text style={[formsStyles.labelStyle]}>
          {label} {required && <Text>*</Text>} :
        </Text>
      )}
    </View>
  );
};
